<template>
  <el-form-item :label="$attrs.label" :prop="$attrs.name" class="elsa-input" :ref="$attrs.name">
    <template slot="label" v-if="information">
      {{ $attrs.label }}
      <el-tooltip v-if="information" :content="information" popper-class="white-space-pre-line">
        <i class="el-icon-info" />
      </el-tooltip>
    </template>
    <el-select v-bind="$attrs" v-on="$listeners">
      <el-checkbox class="selectall-checkbox" v-if="select_all_option" v-on:change="handleSelectAll" :value="selectAllVal">Select All</el-checkbox>
      <el-option v-for="(option, idx) in options" :key="idx" :label="option.label || option.name" :value="option.value || option.id" :disabled="option.disabled || false" />
    </el-select>
  </el-form-item>
</template>

<script>
import { always } from 'ramda'

export default {
  name: 'ElsaSelect',
  props: {
    options: {
      type: Array,
      default: always([])
    },
    information: {
      type: String,
      default: null
    },
    select_all_option: {
      type: Boolean,
      default: false
    },
    selectAllVal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSelectAll(value) {
      this.$emit('selectAll', value)
    }
  }

}
</script>

<style lang="scss" scoped>
.el-form-item.elsa-input {
  display: flex;
  flex-direction: column;
  border-radius: 8px;

  .el-select {
    width: 100%;
    &::v-deep .el-input__inner {
      background: #ffffff;
      box-sizing: border-box;
      font-family: 'SF Pro Display', sans-serif;
      font-size: 16px;
      line-height: 24px;
      color: #000000;
      opacity: 0.6;
      height: 52px;
    }
  }

  .el-tooltip.el-icon-info {
    margin-left: 3px;
    color: #546873 !important;
    font-size: 14px !important;
  }
}

::v-deep.el-select-dropdown__item {
  span {
    text-transform: capitalize;
  }
}
.selectall-checkbox {
  padding: 10px 10px;
  width: 100%;
  border-bottom: 1px solid #ccc;
  position: sticky;
  top: 0px;
  background: #fff;
  z-index: 999;
}
</style>
